var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowDown = function SvgArrowDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7524 15.5516L18.4024 9.89158C18.4962 9.79862 18.5706 9.68801 18.6213 9.56616C18.6721 9.4443 18.6982 9.31359 18.6982 9.18158C18.6982 9.04957 18.6721 8.91886 18.6213 8.797C18.5706 8.67514 18.4962 8.56454 18.4024 8.47158C18.2151 8.28533 17.9616 8.18079 17.6974 8.18079C17.4333 8.18079 17.1798 8.28533 16.9924 8.47158L11.9924 13.4216L7.04244 8.47158C6.85508 8.28533 6.60163 8.18079 6.33744 8.18079C6.07326 8.18079 5.81981 8.28533 5.63244 8.47158C5.53796 8.56419 5.46279 8.67464 5.41129 8.79651C5.35979 8.91839 5.33299 9.04927 5.33245 9.18158C5.33299 9.31389 5.35979 9.44477 5.41129 9.56664C5.46279 9.68852 5.53796 9.79896 5.63244 9.89158L11.2824 15.5516C11.3761 15.6531 11.4897 15.7341 11.6162 15.7895C11.7427 15.8449 11.8793 15.8735 12.0174 15.8735C12.1555 15.8735 12.2922 15.8449 12.4186 15.7895C12.5451 15.7341 12.6588 15.6531 12.7524 15.5516Z",
    fill: "#3A3A3A"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-down.797e4fbe.svg";
export { ForwardRef as ReactComponent };